import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Logo } from "@/components/brand/Logo";

export const AuthShell = ({ title, subtitle, children, testId }) => (
  <div className="grid min-h-screen lg:grid-cols-2" data-testid={testId}>
    <div className="flex flex-col px-6 py-8 sm:px-12">
      <Logo />
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center py-10">
        <h1 className="text-3xl font-bold tracking-tight text-[#0B2D5B]">{title}</h1>
        {subtitle && <p className="mt-2 text-slate-600">{subtitle}</p>}
        <div className="mt-8">{children}</div>
      </div>
      <p className="text-xs text-slate-400"><Link to="/privacy" className="hover:underline">Privacy</Link> · <Link to="/terms" className="hover:underline">Terms</Link></p>
    </div>
    <div className="relative hidden overflow-hidden bg-[#0B2D5B] lg:block">
      <img src="/img/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-40" />
      <div className="relative flex h-full flex-col justify-end p-12 text-white">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-300">Clockaroo</p>
        <p className="font-display mt-3 max-w-md text-4xl font-extrabold leading-tight">Your Team. Your Time. All in One Place.</p>
      </div>
    </div>
  </div>
);

export const GoogleButton = ({ next }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    sessionStorage.setItem("clockaroo.next", next || "/app");
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUri = window.location.origin + "/auth/google";
    try {
      const { data } = await api.post("/auth/google/start", { redirect_uri: redirectUri });
      window.location.href = data.authorization_url;
    } catch (err) {
      toast.error(formatError(err));
      setBusy(false);
    }
  };
  return (
    <button type="button" onClick={go} disabled={busy} data-testid="google-login-btn" className="flex h-11 w-full items-center justify-center gap-2 rounded-xl border border-slate-300 bg-white text-sm font-semibold transition-colors hover:bg-slate-50">
      <svg viewBox="0 0 48 48" className="h-5 w-5"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" /><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" /><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" /><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" /></svg>
      Continue with Google
    </button>
  );
};

export const Divider = () => (
  <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-wider text-slate-400"><span className="h-px flex-1 bg-slate-200" />or<span className="h-px flex-1 bg-slate-200" /></div>
);
